import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ22_V4L: TStep[] = [
  {
    pageId: PageId.SEX_V4L,
  },
  {
    pageId: PageId.DOG_AGE_V4L,
  },
  {
    pageId: PageId.DOG_BREED_V4L,
  },
  {
    pageId: PageId.URGE_V4L,
  },
  {
    pageId: PageId.COMMANDS_61_V4L,
  },
  {
    pageId: PageId.COMMANDS_62_V4L,
  },
  {
    pageId: PageId.COMMANDS_63_V4L,
  },
  {
    pageId: PageId.URGE_2_V4L,
  },
  {
    pageId: PageId.POTTY_V4L,
  },
  {
    pageId: PageId.BEHAVIOR_V4L,
  },
  {
    pageId: PageId.TRAINING_V4L,
  },
  {
    pageId: PageId.PREPARE_FLOW_V4L,
  },
  {
    pageId: PageId.DOG_STATISTICS_V4L,
  },
  {
    pageId: PageId.EMAIL_V4L,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_V4L,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_V4L,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_V4L_2,
  },
  {
    pageId: PageId.CHAT_UPSELL_V4L,
  },
  {
    pageId: PageId.UPSELL_V4L,
  },
  {
    pageId: PageId.UPSELL_PITPAT_V4L,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_V4L,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V4L.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V4L.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
